export default {
  init() {
    $('body').on('click', '.js-accordiontitle', function(event) {
      event.preventDefault();

      var $el = $(this);
      var $parent = $el.parent();
      $('.js-accordiontitle').parent().not($parent).removeClass('is-active')

      if ($parent.hasClass('is-active')) {
        $parent.removeClass('is-active');
      } else {
        $parent.addClass('is-active');
      }
    });

    $('.postfilter .js-postfilterselect').on('click', function (){
        $(this).parent('.postfilter').toggleClass('is-showing');
    });

    var sizeExpanderText = function() {

      // Set exander text width so that it doesn't freak out on resize
      var $expanderText = $('.js-expander').find('.posts__postpreview__text');

      $expanderText.css('width', '');

      $expanderText.each(function() {
        var width = $(this).innerWidth();
        $(this).css('width', width);
      });
    }

    $('.js-expander').hover(function() {
      $('.js-expander').not(this).addClass('not-hovered');
    }, function() {
      $('.js-expander').removeClass('not-hovered');
    });


    $(window).resize(sizeExpanderText);

    sizeExpanderText();


  },
}



// WEBPACK FOOTER //
// ./scripts/components/accordion.js